import { ArticleMetaData } from "../../articles/types/ArticleMetaData";

export const WorkMetaData = ArticleMetaData.pick({
	abridged: true,
	additionalLanguages: true,
	bisacCodes: true,
	bokgruppe: true,
	contributors: true,
	imprint: true,
	language: true,
	mainThemaCode: true,
	name: true,
	originalLanguage: true,
	originalName: true,
	serie: true,
	serieNumber: true,
	subtitle: true,
	synopsis: true,
	tags: true,
	themaCodes: true,
});
